module.exports = __webpack_public_path__ + "static/media/Marta Piroli.c0080141.png";